import css from "./ItemsBlock.module.css";

import { Link } from "react-router";
import { Icon } from "../ui/Icon";
import { useRealm, useT, useTurl } from "~/util/Lang";
import { CrystalColor } from "../item/Crystal";
import { Heading2 } from "../ui/Heading";

export function ItemsBlock() {
  const turl = useTurl();
  const t = useT();
  const { game } = useRealm();
  const grades =
    game === "c1" || game === "c2" || game === "c3" ? gradesC1 : gradesC4;

  return (
    <>
      <Heading2>{t({ en: "Items", ru: "Предметы" })}</Heading2>
      <div className="columns">
        <div className="column">
          <h2 className={css.heading}>{t({ en: "Weapons", ru: "Оружие" })}</h2>
          <ul className={css.list}>
            {weapons.map((weapon, i) => (
              <li className={css.item} key={i}>
                <div className={css.title}>
                  <Icon icon={weapon.icon} size={16} />
                  <Link to={turl(`/items/weapon?f=${weapon.type};canGet:true`)}>
                    {t(weapon.name)}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/weapon?f=grade:${grade.type};${weapon.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="column">
          <h2 className={css.heading}>{t({ en: "Armor", ru: "Броня" })}</h2>
          <ul className={css.list}>
            {armors.map((armor, i) => (
              <li className={css.item} key={i}>
                <div className={css.title}>
                  <Icon icon={armor.icon} size={16} />
                  <Link
                    to={turl(
                      `/items/${armor.path}?f=${armor.type};canGet:true`
                    )}
                  >
                    {t(armor.name)}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/${armor.path}?f=grade:${grade.type};${armor.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <h2 className={css.heading}>
            {t({ en: "Jewelry", ru: "Ювелирные украшения" })}
          </h2>
          <ul className={css.list}>
            {jewels.map((jewelry, i) => (
              <li className={css.item} key={i}>
                <div className={css.title}>
                  <Icon icon={jewelry.icon} size={16} />
                  <Link
                    to={turl(`/items/jewelry?f=${jewelry.type};canGet:true`)}
                  >
                    {t(jewelry.name)}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/jewelry?f=grade:${grade.type};${jewelry.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="column"></div>
      </div>
    </>
  );
}

const gradesC1 = [
  { name: "NG", type: "none" },
  { name: "D", type: "d" },
  { name: "C", type: "c" },
  { name: "B", type: "b" },
  { name: "A", type: "a" },
];

const gradesC4 = [...gradesC1, { name: "S", type: "s" }];

const armors = [
  {
    name: { en: "Robe", ru: "Магические доспехи" },
    path: "armor",
    type: "at:magic",
    icon: "armor_tunic_of_devotion_i00",
  },
  {
    name: { en: "Light", ru: "Легкие доспехи" },
    path: "armor",
    type: "at:light",
    icon: "armor_wooden_breastplate_i00",
  },
  {
    name: { en: "Heavy", ru: "Тяжелые доспехи" },
    path: "armor",
    type: "at:heavy",
    icon: "armor_bronze_breastplate_i00",
  },
  {
    name: { en: "Helmets", ru: "Шлемы" },
    path: "armor",
    type: "slot:head",
    icon: "armor_leather_helmet_i00",
  },
  {
    name: { en: "Gloves", ru: "Перчатки" },
    path: "armor",
    type: "slot:gloves",
    icon: "armor_gloves_i00",
  },
  {
    name: { en: "Boots", ru: "Сапоги" },
    path: "armor",
    type: "slot:feet",
    icon: "armor_leather_sandals_i00",
  },
  {
    name: { en: "Shields", ru: "Щиты" },
    path: "shield",
    type: "slot:lhand",
    icon: "shield_small_shield_i00",
  },
];

const weapons = [
  {
    name: { en: "Swords", ru: "Мечи" },
    type: "wt:sword",
    icon: "weapon_small_sword_i00",
  },
  {
    name: { en: "Blunts", ru: "Дубины" },
    type: "wt:blunt",
    icon: "weapon_club_i00",
  },
  {
    name: { en: "Daggers", ru: "Кинжалы" },
    type: "wt:dagger",
    icon: "weapon_doomed_dagger_i00",
  },
  {
    name: { en: "Bows", ru: "Луки" },
    type: "wt:bow",
    icon: "weapon_hunting_bow_i00",
  },
  {
    name: { en: "Fists", ru: "Кастеты" },
    type: "wt:dualfist",
    icon: "weapon_vipers_canine_i00",
  },
  {
    name: { en: "Pole", ru: "Копья" },
    type: "wt:pole",
    icon: "weapon_short_spear_i00",
  },
  {
    name: { en: "Duals", ru: "Парные мечи" },
    type: "wt:dual",
    icon: "weapon_dual_sword_i00",
  },
];

const jewels = [
  {
    name: { en: "Necklaces", ru: "Ожерелья" },
    type: "slot:neck",
    icon: "accessary_necklace_of_magic_i00",
  },
  {
    name: { en: "Earings", ru: "Серьги" },
    type: "slot:ear",
    icon: "accessary_apprentices_earing_i00",
  },
  {
    name: { en: "Rings", ru: "Кольца" },
    type: "slot:finger",
    icon: "accessary_magic_ring_i00",
  },
];
